import React, { useState, useEffect } from 'react';

import { Dropdown } from "components";

import { convertArrayToDropdownArrayFormat, func_validation, isArrayNotEmpty } from "functions";
import { FormInput_text } from 'components/form/formInput/FormInput_text';

export function useCompanyInputs(props) {
    // Props
    
    const {
        isEditing,

        advancePaySetup,
        isFormSubmissionAttempted,
        
        comIdList,
        accountCodeList,
        // dealerCodeList,
        // salesPersonCodeList,
        fullAgentCodeList,

        // Functions
        getFullAgentCodeList = () => {},
    } = props;

    let companyId_original = func_validation.getObjectPropertyValue(advancePaySetup, "CompanyId");
    let accountCode_original = func_validation.getObjectPropertyValue(advancePaySetup, "AccountCode");
    let glAccountCode_original = advancePaySetup?.GLAccountCode? advancePaySetup.GLAccountCode: (!isEditing? "5000-000":"");
    let dealerCode_original = func_validation.getObjectPropertyValue(advancePaySetup, "DealerCode");
    let salesPersonCode_original = func_validation.getObjectPropertyValue(advancePaySetup, "SalesPersonCode");


    // States
    const [companyId, setCompanyId] = useState(companyId_original);
    const [accountCode, setAccountCode] = useState(accountCode_original);
    const [glAccountCode, setGLAccountCode] = useState(glAccountCode_original);
    const [dealerCode, setDealerCode] = useState(dealerCode_original);
    const [salesPersonCode, setSalesPersonCode] = useState(salesPersonCode_original);
    const [isAnyInputChanged, setIsAnyInputChanged] = useState(false);
    const [dealerCodeList, setDealerCodeList] = useState();
    const [salesPersonCodeList, setSalesPersonCodeList] = useState();


    // Check for changes in input from initial
    useEffect(() => {
        let isNotChangedFromOriginal = (
            companyId === companyId_original &&
            accountCode === accountCode_original &&
            glAccountCode === glAccountCode_original &&
            dealerCode === dealerCode_original &&
            salesPersonCode === salesPersonCode_original
        );

        let isChangedFromEmpty = (
            companyId ||
            accountCode ||
            glAccountCode ||
            dealerCode ||
            salesPersonCode
        )

        setIsAnyInputChanged(isEditing? !isNotChangedFromOriginal: isChangedFromEmpty);  
    }, [
        companyId, accountCode, glAccountCode, dealerCode, salesPersonCode
    ]);

    // Get Dealer and Sales Person Codes FULL list (Not just from existing setups)
    useEffect(() => {
        getFullAgentCodeList();
    }, []);

    useEffect(() => {
        if (isArrayNotEmpty(fullAgentCodeList)) {
            let dealerList = [], salesPersonList = [];
            fullAgentCodeList.map((item) => {
                let isDealerCode = item.indexOf("200");
                let isSalesPersonCode = item.indexOf("100");

                if (isDealerCode) dealerList.push(item);
                if (isSalesPersonCode) salesPersonList.push(item);
            })

            setDealerCodeList(dealerList);
            setSalesPersonCodeList(salesPersonList);
        }
    }, [fullAgentCodeList]);
    
    // Display
    let display = (
        <div className={"input-wrapper__company d-flex flex-wrap"}>
            {/* Company Id */}
            <Dropdown
                className={"company__company-id"}
                label={"Company ID"}
                isInputRequired

                selectedValueClassName={"company-id__input"}

                options={comIdList}
                valueFromParent={companyId}
                selectedValue_default={companyId}
                onChange={setCompanyId}

                errorMsg={"Required"}

                isFormSubmissionAttempted={isFormSubmissionAttempted}
                isInputDigitOnly isSearchable
            />

            {/* Account Code */}
            <Dropdown
                className={"company__account-code"}
                label={"Account Code"}
                isInputRequired

                selectedValueClassName={"account-code__input"}

                options={accountCodeList}
                valueFromParent={accountCode}
                selectedValue_default={accountCode}
                onChange={setAccountCode}

                errorMsg={"Required"}

                isFormSubmissionAttempted={isFormSubmissionAttempted}
                isSearchable
            />

            {/* GL Account Code */}
            <FormInput_text  
                inputLabel={"GL Account Code"}

                className={"company__gl-account-code"}
                inputValue_default={glAccountCode} 

                isInputBlurHandlingRequired
                handleInputBlurExtend={(value) => { setGLAccountCode(value); }}

                customErrorMsgDefault={"Required"}
                isFormSubmissionAttempted={isFormSubmissionAttempted} 

                isInputValueTrim_onChange
                isMarginBtmOptional
            />

            {/* Dealer Code */}
            <Dropdown
                className={"company__dealer-code"}
                label={"Dealer Code"}

                selectedValueClassName={"dealer-code__input"}

                options={convertArrayToDropdownArrayFormat(dealerCodeList)}
                valueFromParent={dealerCode}
                selectedValue_default={dealerCode}
                onChange={setDealerCode}

                isSearchable
            />

            {/* Sales Person Code */}
            <Dropdown
                className={"company__sales-person-code"}
                label={"Sales Person Code"}

                selectedValueClassName={"sales-person-code__input"}

                options={convertArrayToDropdownArrayFormat(salesPersonCodeList)}
                valueFromParent={salesPersonCode}
                selectedValue_default={salesPersonCode}
                onChange={setSalesPersonCode}

                isSearchable
            />
        </div>
    );

    let isEveryInputValid = (
        func_validation.isNumberValid(companyId) &&
        func_validation.isStringTrimNotEmpty(accountCode) &&
        func_validation.isStringTrimNotEmpty(glAccountCode)
        // func_validation.isStringTrimNotEmpty(dealerCode) &&
        // func_validation.isStringTrimNotEmpty(salesPersonCode) &&
    );

    let companyDetails = {
        CompanyId: companyId,
        AccountCode: accountCode,
        GLAccountCode: glAccountCode,
        DealerCode: func_validation.isStringTrimNotEmpty(dealerCode)? dealerCode:"",
        SalesPersonCode: func_validation.isStringTrimNotEmpty(salesPersonCode)? salesPersonCode:"",
    }

    return {
        companyId, accountCode, glAccountCode,
        companyDetails,

        isEveryInputValid,
        isAnyInputChanged,

        display
    }
}